export const phoneNumberCapturePredefinedPage = {
  name: 'phone',
  className: '',
  elements: [
    {
      kind: 'TEXT',
      type: 'TITLE',
      className: 'description phone__description',
      value: 'What is your phone number to reach you?'
    },
    {
      kind: 'CONTAINER',
      className: 'phone__form__container',
      keys: [],
      children: [
        {
          kind: 'TEXT',
          type: 'PARAGRAPH',
          className: 'label phone__label',
          value: 'Phone Number'
        },
        {
          kind: 'FORM',
          type: 'PHONE',
          className: 'phone__input',
          placeholder: 'Please enter your phone number',
          key: 'phoneNumber',
          validations: {
            required: {
              value: true,
              message: 'Phone Number is required'
            },
            regex: {
              value: false
            }
          }
        }
      ]
    },
    {
      kind: 'CONTAINER',
      className: 'navigation__container',
      keys: [],
      children: [
        {
          kind: 'BUTTON',
          className: 'next__button',
          value: 'NEXT',
          role: 'NEXT'
        },
        {
          kind: 'BUTTON',
          className: 'back__button',
          value: 'BACK',
          role: 'BACK'
        }
      ]
    }
  ],
  nextPage: {},
  layouts: {
    beforeElements: '',
    afterElements: ''
  }
}
